export const DRAFT_NODE_ID = "draft";
export const INVESTOR_GROUP_PREFIX = "investors-in";
